import { APP_INITIALIZER } from '@angular/core';
import { provideTranslateService, TranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { catchError, firstValueFrom, of } from 'rxjs';

const DEFAULT_LANGUAGE = 'es';

function initializeAppLanguage(translateService: TranslateService) {
  return () =>
    firstValueFrom(translateService.use(DEFAULT_LANGUAGE).pipe(catchError(() => of(null))));
}

export const provideLanguage = [
  provideTranslateService({
    loader: provideTranslateHttpLoader({
      prefix: '/i18n/',
      suffix: '.json',
      enforceLoading: false,
      useHttpBackend: false,
    }),
    fallbackLang: DEFAULT_LANGUAGE,
    lang: DEFAULT_LANGUAGE,
  }),
  {
    provide: APP_INITIALIZER,
    useFactory: initializeAppLanguage,
    deps: [TranslateService],
    multi: true,
  },
];


